import { useEffect, useState } from "react";
import { CLUSTERS } from "@/data/content";

export const ClusterSubnav = () => {
  const [active, setActive] = useState("a");
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const ids = CLUSTERS.map((c) => `cluster-${c.id.toLowerCase()}`);
    const els = ids.map((id) => document.getElementById(id)).filter(Boolean);
    if (!els.length) return;

    const featuresSection = document.getElementById("features");

    const onScroll = () => {
      if (featuresSection) {
        const rect = featuresSection.getBoundingClientRect();
        // Show subnav once the features section reaches the sticky offset
        setVisible(rect.top <= 96 && rect.bottom > 200);
      }
      // Determine active cluster: the last one whose top is above the trigger line
      const triggerY = 200;
      let current = els[0].id;
      for (const el of els) {
        const top = el.getBoundingClientRect().top;
        if (top <= triggerY) current = el.id;
      }
      setActive(current.replace("cluster-", ""));
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  const handleClick = (e, id) => {
    e.preventDefault();
    const el = document.getElementById(`cluster-${id.toLowerCase()}`);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div
      className={`fixed left-0 right-0 top-16 md:top-20 z-40 transition-all duration-300 ${
        visible ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 -translate-y-2 pointer-events-none"
      }`}
      data-testid="cluster-subnav"
    >
      <div className="backdrop-blur-md bg-bone/85 border-b border-ink/10">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
          <div className="flex items-center gap-1 sm:gap-2 overflow-x-auto no-scrollbar h-11 md:h-12">
            <span className="hidden md:inline text-[10px] uppercase tracking-[0.22em] text-ink/40 mr-3 shrink-0">
              Jump to
            </span>
            {CLUSTERS.map((c) => {
              const isActive = active === c.id.toLowerCase();
              return (
                <a
                  key={c.id}
                  href={`#cluster-${c.id.toLowerCase()}`}
                  onClick={(e) => handleClick(e, c.id)}
                  data-testid={`subnav-link-${c.id.toLowerCase()}`}
                  className={`group relative shrink-0 flex items-center gap-2 px-3 md:px-4 h-8 md:h-9 text-xs md:text-[13px] rounded-full transition-colors duration-200 ${
                    isActive
                      ? "bg-ink text-bone"
                      : "text-ink/70 hover:text-ink hover:bg-ink/5"
                  }`}
                >
                  <span
                    className={`font-serif text-sm md:text-base leading-none ${
                      isActive ? "text-coral" : "text-coral/70"
                    }`}
                  >
                    {c.id}
                  </span>
                  <span className="whitespace-nowrap">{c.title}</span>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
